import { useState } from "react";

import { ResponsiveDialog } from "../modal";
import { DialogTitle, Typography } from "@mui/material";
import { DialogContent } from "@mui/material";
import { LoginForm, SignUpForm } from "../login/accountForms";
import { Action } from "../login/common";
import { T } from "../util/t";
import { useCurrentUser } from "../providers/CurrentUserProvider";

export const RegisterOrLoginModal = () => {
    const { loaded, currentUser } = useCurrentUser();

    return (
        <ResponsiveDialog
            className="register-or-login-dialog lh-dialog"
            fullWidth={true}
            maxWidth="xs"
            open={!!(loaded && !currentUser)}
            aria-labelledby="register-or-login-dialog-title"
        >
            <RegisterOrLoginModalContent/>
        </ResponsiveDialog>
    );
};

const RegisterOrLoginModalContent = () => {
    const [viewLogin, setViewLogin] = useState(true);
    const toggleView = () => setViewLogin(!viewLogin);

    return (
        <div className="login-card scrollable-area">
            <DialogTitle id="register-or-login-dialog-title">
                <Typography variant="h1" component="span">
                    {viewLogin ? <T>Log in to Liveheats</T> : <T>Create Liveheats account</T>}
                </Typography>
            </DialogTitle>
            <DialogContent>
                {viewLogin ?
                    <Action text="Don't have an account?" buttonText="Sign up" onClick={toggleView}/> :
                    <Action text="Already have an account?" buttonText="Log in" onClick={toggleView}/>
                }
                {viewLogin ?
                    <LoginForm preventRedirect/> :
                    <SignUpForm preventRedirect/>
                }
            </DialogContent>
        </div>
    );
};
